import React, { Suspense, lazy } from 'react';
import { TopBar } from '../components/landing/TopBar';
import { MarqueeBanner } from '../components/landing/MarqueeBanner';
import { Navbar } from '../components/landing/Navbar';
import { HeroSection } from '../components/landing/HeroSection';
import { BloodDripEffect } from '../components/landing/BloodDripEffect';
// Lazy load below-the-fold sections
const FeaturedReview = lazy(() => import('../components/landing/FeaturedReview').then(m => ({
  default: m.FeaturedReview
})));
const CasesAccordion = lazy(() => import('../components/landing/CasesAccordion').then(m => ({
  default: m.CasesAccordion
})));
const ExperienceSection = lazy(() => import('../components/landing/ExperienceSection').then(m => ({
  default: m.ExperienceSection
})));
const OfferSection = lazy(() => import('../components/landing/OfferSection').then(m => ({
  default: m.OfferSection
})));
const EvidenceSection = lazy(() => import('../components/landing/EvidenceSection').then(m => ({
  default: m.EvidenceSection
})));
const ReviewsGrid = lazy(() => import('../components/landing/ReviewsGrid').then(m => ({
  default: m.ReviewsGrid
})));
const FAQSection = lazy(() => import('../components/landing/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/landing/Footer').then(m => ({
  default: m.Footer
})));
export function LandingPage() {
  return <div style={{
    backgroundColor: '#000000',
    minHeight: '100vh'
  }} data-id="element-238">
      {/* Fixed top elements */}
      <MarqueeBanner data-id="element-239" />
      <TopBar data-id="element-240" />
      <Navbar data-id="element-241" />

      {/* Main content — offset for MarqueeBanner (36px) + TopBar (44px) = 80px */}
      <main style={{
      paddingTop: '80px'
    }} data-id="element-242">
        {/* Blood drip effect covers the entire landing */}
        <div className="relative overflow-hidden bg-black" data-id="element-243">
          <BloodDripEffect data-id="element-244" />
          <div className="relative z-10" data-id="element-245">
            {/* Hero loads eagerly — above the fold */}
            <HeroSection data-id="element-246" />

            {/* Everything below is lazy-loaded */}
            <Suspense fallback={<div style={{
            minHeight: '200px'
          }} data-id="element-248" />} data-id="element-247">
              <FeaturedReview data-id="element-249" />
              <CasesAccordion data-id="element-250" />
              <ExperienceSection data-id="element-251" />
              <OfferSection data-id="element-252" />
              <EvidenceSection data-id="element-253" />
              <ReviewsGrid data-id="element-254" />
              <FAQSection data-id="element-255" />
              <Footer data-id="element-256" />
            </Suspense>
          </div>
        </div>
      </main>
    </div>;
}